import { render, staticRenderFns } from "./TradingAccount.vue?vue&type=template&id=46a0dc9a&scoped=true&"
import script from "./TradingAccount.vue?vue&type=script&lang=js&"
export * from "./TradingAccount.vue?vue&type=script&lang=js&"
import style0 from "./TradingAccount.vue?vue&type=style&index=0&id=46a0dc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0dc9a",
  null
  
)

export default component.exports